var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBagBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7615 16.9167H4.80495C2.24965 16.9167 0.289314 15.9937 0.84614 12.279L1.4945 7.24466C1.83775 5.39111 3.02005 4.68173 4.05743 4.68173H12.5395C13.5921 4.68173 14.7058 5.44451 15.1024 7.24466L15.7508 12.279C16.2237 15.5742 14.3168 16.9167 11.7615 16.9167Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.876 4.49865C11.876 2.51026 10.2641 0.898348 8.27572 0.898348V0.898348C7.31822 0.894291 6.39854 1.27182 5.72005 1.94744C5.04156 2.62307 4.66015 3.54114 4.66016 4.49865H4.66016",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7471 8.25151H10.709",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.88776 8.25151H5.84962",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBagBlack);
export default __webpack_public_path__ + "static/media/Bag-black.08f903fdcbe2284be2134511ea1373f1.svg";
export { ForwardRef as ReactComponent };